import { render } from "./FeedbackFlow.vue?vue&type=template&id=15b6f18d&scoped=true&ts=true"
import script from "./FeedbackFlow.vue?vue&type=script&lang=ts"
export * from "./FeedbackFlow.vue?vue&type=script&lang=ts"

import "./FeedbackFlow.vue?vue&type=style&index=0&id=15b6f18d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b6f18d"]])

export default __exports__